// Feb 1, 2016. It's the first date on which we can obtain meaningfull data from our system
export const CHOPIN_RFQS_DATA_START_DATE = new Date(2016, 1, 1); // Month is 0-based
// Sep 2013, First date on which we can obtain policy cover transactions from our system
export const POLICIES_DATA_START_DATE = new Date(2013, 8, 1);
// Jan 2018. Loss Ratio reports include data from Marketplace, which LAPD decomissioned.
// We currently don't have all the info about those policies.
export const LOSS_RATIO_START_DATE = new Date(2018, 1, 1);
